// extracted by mini-css-extract-plugin
export var arbiterSwatch = "_2b-3";
export var dialog = "_2b-0";
export var divClassnameSwatch = "_2b-8";
export var flexSwatch = "_2b-4";
export var header = "_2b-1";
export var styleAttributeSwatch = "_2b-7";
export var swatch = "_2b-2";
export var textHeaderSwatch = "_2b-5";
export var webSwatch = "_2b-6";